module.exports = __webpack_public_path__ + "img/SoftwareCopyright_11.4f8c76e5.png";